import React from 'react'

export default () => <footer style={{
        textAlign: 'center',
        margin: 'auto',
        margin: 20,
        color: '#242424'
      }}>
      
        <span style={{
            display: 'inline-block',
            maxWidth: 600
        }}>
            <i>
                This is a practice React app that connects to a cat photos API to display random and cute cat photos and fun facts and lets you save them to your browser storage. This project was inspired by my fellow codecampmates and built by me to demonstrate and practice the lessons learned in class.
            </i>
        
            <div style={{padding: 10}}>
                <a href="https://fromjon.com"> Browse more apps at <u>  FromJon.com</u></a>
            </div>
        </span>
      </footer>

